import { render, staticRenderFns } from "./DistintaBase.vue?vue&type=template&id=68517ae8&scoped=true&"
import script from "./DistintaBase.vue?vue&type=script&lang=js&"
export * from "./DistintaBase.vue?vue&type=script&lang=js&"
import style0 from "./DistintaBase.vue?vue&type=style&index=0&id=68517ae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68517ae8",
  null
  
)

export default component.exports